module.exports = __webpack_public_path__ + "img/Dimas Bagaskara.6c8bb745.jpg";